// Web stub for react-native-geolocation-service (bridges to browser geolocation)
const Geolocation = {
  getCurrentPosition: (success, error, options) => {
    if (typeof navigator !== 'undefined' && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(success, error, options)
    } else if (error) {
      error({ code: 2, message: 'geolocation unavailable' })
    }
  },
  watchPosition: (success, error, options) => {
    if (typeof navigator !== 'undefined' && navigator.geolocation) {
      return navigator.geolocation.watchPosition(success, error, options)
    }
    return 0
  },
  clearWatch: (id) => {
    if (typeof navigator !== 'undefined' && navigator.geolocation) {
      navigator.geolocation.clearWatch(id)
    }
  },
  stopObserving: () => {},
  requestAuthorization: async () => 'granted',
}
export default Geolocation
